{
  "name": "am-kiosk",
  "version": "9.37.7",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:coverage": "ng test --code-coverage --watch=false",
    "test:ci": "ng test --watch=false --browsers=ChromeHeadless",
    "extract": "ngx-translate-extract --input ./src --output ./src/assets/i18n/*.json --format namespaced-json",
    "lint": "eslint \"src/**/*.ts\" --max-warnings=0",
    "lint:fix": "eslint \"src/**/*.ts\" --fix",
    "format": "prettier --write .",
    "commit": "node scripts/commit.mjs",
    "changelog": "conventional-changelog -p angular -i CHANGELOG.md -s",
    "changelog:full": "conventional-changelog -p angular -i CHANGELOG.md -s -r 0",
    "prepare": "husky install"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "20.3.25",
    "@angular/common": "20.3.25",
    "@angular/compiler": "20.3.25",
    "@angular/core": "20.3.25",
    "@angular/forms": "20.3.25",
    "@angular/localize": "20.3.25",
    "@angular/platform-browser": "20.3.25",
    "@angular/platform-browser-dynamic": "20.3.25",
    "@angular/router": "20.3.25",
    "@ng-bootstrap/ng-bootstrap": "^19.0.0",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@popperjs/core": "^2.11.8",
    "@types/google.maps": "^3.58.1",
    "angular-google-tag-manager": "~1.12.0",
    "angularx-qrcode": "~20.0.0",
    "bootstrap": "^5.2.0",
    "jsencrypt": "3.5.4",
    "moment": "^2.29.4",
    "moment-timezone": "^0.5.48",
    "ngx-mask": "^18.0.4",
    "rxjs": "~7.8.0",
    "sweetalert2": "^11.7.5",
    "tslib": "^2.3.0",
    "uuid": "^14.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "20.3.25",
    "@angular/cli": "20.3.25",
    "@angular/compiler-cli": "20.3.25",
    "@types/jasmine": "^5.1.15",
    "@types/node": "^22.19.17",
    "@typescript-eslint/eslint-plugin": "^5.59.11",
    "@typescript-eslint/parser": "^5.59.11",
    "conventional-changelog-cli": "^4.1.0",
    "eslint": "^8.18.0",
    "eslint-config-prettier": "^8.8.0",
    "eslint-plugin-diff": "^2.1.7",
    "eslint-plugin-prettier": "^4.2.1",
    "fast-check": "4.9.0",
    "husky": "^8.0.1",
    "inquirer": "^9.3.8",
    "jasmine-core": "~4.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.1.0",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "~1.7.0",
    "lint-staged": "^13.2.1",
    "prettier": "^2.8.8",
    "typescript": "~5.8.3"
  },
  "lint-staged": {
    "*.{ts,js}": [
      "prettier --write",
      "eslint --fix --max-warnings=100"
    ],
    "*.{html,scss,css}": [
      "prettier --write"
    ]
  }
}
